/**
 * Hook para obtener datos de logística usando React Query
 * Hook to get logistics data using React Query
 */

import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { LogisticsApiAdapter } from '../adapters';
import { LogisticsApiResponse } from '../models/LogisticsApiResponse';
import { LogisticsFilters } from '../models/LogisticsFilters';

interface UseLogisticsDataProps {
  filters?: LogisticsFilters;
}

export const useLogisticsData = ({ filters }: UseLogisticsDataProps = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const logisticsAdapter = new LogisticsApiAdapter(httpClient);

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<LogisticsApiResponse>({
    queryKey: ['logisticsReport', filters],
    queryFn: () => logisticsAdapter.getLogisticsReport(filters),
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000, // 5 minutos
    // Mantener los datos anteriores mientras se cargan los nuevos filtros
    // Keep previous data while fetching new filters
    keepPreviousData: true,
  });

  return {
    data: response?.data,
    globalMetrics: response?.data?.global_metrics,
    productMetrics: response?.data?.product_metrics || [],
    dailyMetrics: response?.data?.daily_metrics || [],
    filters: response?.data?.filters,
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};

